'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ShowHideButton = function (_Component) {
  _inherits(ShowHideButton, _Component);

  function ShowHideButton(props) {
    _classCallCheck(this, ShowHideButton);

    //bind this to the following
    var _this = _possibleConstructorReturn(this, (ShowHideButton.__proto__ || Object.getPrototypeOf(ShowHideButton)).call(this, props));

    _this.toggleVisibleCBClick = _this.toggleVisibleCBClick.bind(_this);
    return _this;
  }

  _createClass(ShowHideButton, [{
    key: 'toggleVisibleCBClick',
    value: function toggleVisibleCBClick() {
      this.props.toggleVisibleCB(this.props.isVisible, this.props.id);
    }
  }, {
    key: 'render',
    value: function render() {
      var className = "ccd-btn btn-square btn-image ";
      var title = "";

      if (this.props.isVisible === true) {
        className += "hideSectionButton";
        title = "Hide Section";
      } else {
        className += "showSectionButton";
        title = "Show Section";
      }

      return _react2.default.createElement('button', { type: 'button', className: className, onClick: this.toggleVisibleCBClick, title: title });
    }
  }]);

  return ShowHideButton;
}(_react.Component);

ShowHideButton.propTypes = {
  toggleVisibleCB: _propTypes2.default.func,
  id: _propTypes2.default.number,
  isVisible: _propTypes2.default.bool
};

exports.default = ShowHideButton;


//////////////////
// WEBPACK FOOTER
// ./node_modules/updox-care-record-viewer/lib/reactComponents/buttons/ShowHideButton.js
// module id = 1238
// module chunks = 0